import React, { ReactElement } from 'react'
import i18n from 'live/services/i18n';
import { Container, Div50, ResizableDiv } from './styles/select_styles'
import ListAsync from './ListAsync'
import type { OptionType } from '../../../common/types/utilities'
import { Entries, Lookup } from '../../../common/types/api/LiveLookupResponse'
import { callbackLookup, callbackLookupValues, onLookupSelected, onLookupValueSelected } from './helper'
import { ActionMeta, OptionTypeBase } from 'react-select'

interface LookupSelectProps {
    width?: number
    lookupName?: string
    lookupValues?: string[]
    onChange: (name: string, values: string[]) => void
    getLookup: () => Promise<Lookup[]>
    getLookupValues: (lookup: string) => Promise<Entries[]>
    editMode: boolean
}

const LookupSelect = ({
    onChange,
    getLookup,
    getLookupValues,
    lookupName,
    lookupValues = [],
    editMode,
    width
}: LookupSelectProps): ReactElement => {
    return (
        <Container style={{ width }}>
            <ResizableDiv>
                <Div50>
                    <ListAsync
                        placeholder={'Lookup Name / Lookup Key'}
                        getApi={getLookup}
                        value={lookupName ? { value: lookupName, label: lookupName } : null}
                        onChange={(option, action) => {
                            const selectedOption = option as OptionType
                            // clear lookup-values in case of diferent lookup-name selected
                            if (selectedOption.label !== lookupName) {
                                onChange(onLookupSelected(option as OptionType, action), lookupValues)
                                onChange(
                                    selectedOption.value as string,
                                    onLookupValueSelected(
                                        [{ label: '', value: '' }] as OptionType[],
                                        { action: 'clear' } as ActionMeta<OptionTypeBase>
                                    )
                                )
                            }
                        }}
                        callback={callbackLookup}
                        disabled={!editMode}
                        editMode={editMode}
                        useLabels={false}
                    />
                </Div50>
                <Div50>
                    <ListAsync
                        placeholder={i18n('Select possible values')}
                        value={lookupValues.map(value => ({ value, label: value }))}
                        onChange={(option: OptionType[], action) =>
                            onChange(lookupName, onLookupValueSelected(option, action))
                        }
                        disabled={!lookupName || !editMode}
                        getApi={() => new Promise(resolve => resolve(getLookupValues(lookupName)))}
                        isMulti={true}
                        callback={callbackLookupValues}
                        isClearable={true}
                        editMode={editMode}
                    />
                </Div50>
            </ResizableDiv>
        </Container>
    )
}

export type { OptionType, LookupSelectProps }
export default LookupSelect
